import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useSmsTemplate from "../../../hooks/useSmsTemplate";

function SmsSection({ title, items, setAffect, setEditItem, setAddModalOpen }) {
  const [open, setOpen] = useState(true);
  // const [editItem, setEditItem] = useState({});

  console.log(items);

  return (
    <div className="p-4">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <h2 className="text-lg font-semibold">{title}</h2>

        <span
          className={`text-xl transition-transform duration-200 ${
            open ? "rotate-180" : "rotate-0"
          }`}
        >
          <KeyboardArrowDownIcon />
        </span>
      </div>

      {open && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
          {items?.map((item, index) => (
            // <Card key={index} item={item} />
            <Card
              item={item}
              onEdit={(item) => {
                setEditItem(item);
                setAddModalOpen(true);
              }}
              setAffect={setAffect}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SmsSection;

const Card = ({ item, onEdit, setAffect }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingItem, setDeletingItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const { deleteSmsTemplate } = useSmsTemplate();

  const handleDeleteClick = (item) => {
    setDeletingItem(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    const result = await deleteSmsTemplate(setLoading, deletingItem.key);
    if (result.success) {
      setShowDeleteModal(false);
      setAffect((p) => p + 1);
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="bg-white border rounded-lg p-4 shadow-sm flex flex-col justify-between relative">
        {/* Top actions */}
        <div className="absolute top-3 right-3 flex items-center gap-2">
          <button
            onClick={() => onEdit(item)}
            className="p-1.5 rounded-md hover:bg-gray-100 text-gray-600 hover:text-blue-600 transition"
            title="Edit"
          >
            <FiEdit2 size={18} />
          </button>

          <button
            onClick={() => handleDeleteClick(item)}
            className="p-1.5 rounded-md hover:bg-gray-100 text-gray-600 hover:text-red-600 transition"
            title="Delete"
          >
            <FiTrash2 size={18} />
          </button>
        </div>

        {/* Card content */}
        <div className="flex flex-col space-y-4 mt-6">
          <span className="font-medium text-lg text-[#2E2E32] whitespace-nowrap">
            {item?.key}
          </span>

          <hr className="border-b border-gray-100" />

          <div className="border border-gray-300 rounded-lg p-3">
            <span className="text-base font-bold text-black leading-relaxed whitespace-pre-line">
              {item?.content}
            </span>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
            <p className="mb-6">
              Are you sure you want to delete "{deletingItem?.key}"?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                disabled={loading}
                onClick={handleConfirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
